class CartDrawer {
    constructor () {
        this.settings = {
            speedOpen: 50,
            speedClose: 350,
            activeClass: 'is-active',
            visibleClass: 'is-visible',
            selectorTarget: '[data-drawer-target]',
            selectorTrigger: '[data-drawer-trigger]',
            selectorClose: '[data-drawer-close]',
        };

        document.addEventListener('click', this.clickHandler.bind(this));
        document.addEventListener('keydown', this.keydownHandler.bind(this));
    }

    getSelectorTrigger () {
        const trigger = document.querySelector(this.settings.selectorTrigger);
        return trigger;
    }

    toggleAccessibility (event) {
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    };

    async openDrawer (trigger) {
      const target = document.getElementById(trigger.getAttribute('aria-controls'));

      if (!target) return;

      const cartData = await fetchCart();
      refreshCart(cartData, 'initCart');

      target.classList.add(this.settings.activeClass);
      document.documentElement.style.overflow = 'hidden';
      this.toggleAccessibility(trigger);

      setTimeout(() => {
        target.classList.add(this.settings.visibleClass);
      }, this.settings.speedOpen);
    };

    closeDrawer (event) {
      let closestParent = event.closest(this.settings.selectorTarget),
        childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');

      closestParent.classList.remove(this.settings.visibleClass);
      document.documentElement.style.overflow = '';
      this.toggleAccessibility(childrenTrigger);

      setTimeout(() => {
        closestParent.classList.remove(this.settings.activeClass);
      }, this.settings.speedClose);
    };

    clickHandler (event) {
      const toggle = event.target;
      const open = toggle.closest(this.settings.selectorTrigger);
      const close = toggle.closest(this.settings.selectorClose);

      if (open)  this.openDrawer(open);
      if (close) this.closeDrawer(close);
      if (open || close) event.preventDefault();
    };

    keydownHandler (event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
        let drawers = document.querySelectorAll(this.settings.selectorTarget);

            for (let i = 0; i < drawers.length; ++i) {
                if (drawers[i].classList.contains(this.settings.activeClass)) {
                    this.closeDrawer(drawers[i]);
                }
            }
        }
    };
};

const cartDrawer = new CartDrawer();

const FREE_GIFT_DISCOUNT_TITLE = 'Free Gift'
const ecoPacksCollectionHandle = 'eco-packs';
const starterKitCollectionHandle = 'frontpage';
const extraCollectionHandle = 'extras';
const addStarterKitButton = document.querySelector(".add_starter-kit");
const starterKitColors = document.querySelectorAll(".starter-kit_colors");
const subscriptionSwitchers = document.querySelectorAll('[name="cart-subscription"]');
const giftConsistentQuantity = window.shippingBar.giftAmount;
const freeGiftId = Number(window.shippingBar.freeGiftId);
const cartCountIcon = document.querySelector("#cart-icon-bubble");
const cartCount = document.createElement("div");
const checkoutButton = document.querySelector("#cart__checkout_btn");
cartCountIcon.append(cartCount);
let nonGiftProductQuantityPrevState;

const isEcoPackItemSellingPlanDiscountDataForMembershipExist =
    Array.isArray(ecoPackCollectionItems[0].selling_plan_groups) &&
    ecoPackCollectionItems[0].selling_plan_groups.length &&
    ecoPackCollectionItems[0].selling_plan_groups[0] &&
    typeof ecoPackCollectionItems[0].selling_plan_groups[0] === 'object' &&
    Array.isArray(ecoPackCollectionItems[0].selling_plan_groups[0].selling_plans) &&
    ecoPackCollectionItems[0].selling_plan_groups[0].selling_plans.length === 12 &&
    Array.isArray(ecoPackCollectionItems[0].selling_plan_groups[0].selling_plans[0].price_adjustments) &&
    ecoPackCollectionItems[0].selling_plan_groups[0].selling_plans[0].price_adjustments.length &&
    ecoPackCollectionItems[0].selling_plan_groups[0].selling_plans[0].price_adjustments[0] &&
    typeof ecoPackCollectionItems[0].selling_plan_groups[0].selling_plans[0].price_adjustments[0] === 'object' &&
    ecoPackCollectionItems[0].selling_plan_groups[0].selling_plans[0].price_adjustments[0].value &&
    ecoPackCollectionItems[0].selling_plan_groups[0].selling_plans[0].price_adjustments[0].value_type;
if (!isEcoPackItemSellingPlanDiscountDataForMembershipExist) {
    throw new Error("Unexpected error: Eco Pack Item Selling Plan Discount Data For Membership do not Exist");
}
const ecoPackItemSellingPlanDiscountDataForMembership = ecoPackCollectionItems[0].selling_plan_groups[0].selling_plans[0].price_adjustments[0];

let starterKitCartItems;
let extraCartItems;
let ecoPackCartItems;

let variantId;
let loading = false;

const state = {
    cartItems: {},
};

let subscriptionCartAmount = 0;
let subscriptionSubtotal = 0;
let isGiftCriteriaConsistent = false;
let isGiftCriteriaConsistentPreviousStates = [
    isGiftCriteriaConsistent,
];

const subscriptionTypes = [
    'membership',
    'one-time',
];
const MEMBERSHIP = subscriptionTypes[0];
const ONE_TIME = subscriptionTypes[1];
let chosenSubscriptionType = MEMBERSHIP;
let chosenSubscriptionTypePreviousStates = [
    chosenSubscriptionType,
];

const generateCartItems = (cartItems, collectionHandle) => {
    let cartTemporaryDataOfProducts = [];

    state.cartItems[collectionHandle] = [];

    const currentCollectionItems = collectionsItems[collectionHandle];

    for (const item of currentCollectionItems) {
        const cartDataOfTheCurrentProduct = cartItems.filter((cartItem) => cartItem.product_id === item.id);

        let cart = null;
        let isGift = false;
        if (cartDataOfTheCurrentProduct.length > 1) {
            for (const cartData of cartDataOfTheCurrentProduct) {
                if (collectionHandle == starterKitCollectionHandle && cartData.quantity > 1) {
                    for (let j = 0; j < cartData.quantity; j++) {
                        cartTemporaryDataOfProducts = [
                            ...cartTemporaryDataOfProducts,
                            {
                                ...item,
                                cart: cartData,
                            }
                        ];
                    }
                } else {
                    cartTemporaryDataOfProducts = [
                        ...cartTemporaryDataOfProducts,
                        {
                            ...item,
                            cart: cartData,
                        }
                    ];
                }
            }
        } else if (cartDataOfTheCurrentProduct.length) {
            cart = cartDataOfTheCurrentProduct[0];

            isGift = cart.final_price === 0 && cart.variant_id === freeGiftId;

            if (isGift) {
                cartTemporaryDataOfProducts = [
                    ...cartTemporaryDataOfProducts,
                    {
                        ...item,
                        cart: null,
                    }
                ];
            }

            if (collectionHandle === starterKitCollectionHandle && cartDataOfTheCurrentProduct.length && cartDataOfTheCurrentProduct[0].quantity > 1) {
                for (let i = 1; i < cartDataOfTheCurrentProduct[0].quantity; i++) {
                    cartTemporaryDataOfProducts = [
                        ...cartTemporaryDataOfProducts,
                        {
                            ...item,
                            cart: cartDataOfTheCurrentProduct[0],
                        }
                    ];
                }
            }
        }

        const generatedData = {
            ...item,
            cart: cart,
        };

        const isStarterKitCollectionAndCartIsEmpty = collectionHandle === starterKitCollectionHandle && !cart;
        if (isStarterKitCollectionAndCartIsEmpty) {
            continue;
        }

        if (cartDataOfTheCurrentProduct.length < 2) {
            state.cartItems[collectionHandle] = [
                ...state.cartItems[collectionHandle],
                generatedData,
            ];
        }
    }
    state.cartItems[collectionHandle] = [
        ...state.cartItems[collectionHandle],
        ...cartTemporaryDataOfProducts,
    ];

    cartTemporaryDataOfProducts = [];
    return state.cartItems[collectionHandle];
}

const renderSubscriptionText = (subscriptionType) => {
    const subscriptionMembershipTextContainer = document.querySelector('#subscription-text-container');
    const subscriptionMembershipText = document.querySelector('#membership-text-container');
    const subscriptionOneTimeTextContainer = document.querySelector('#one-time-text-container');
    const cartCaptionAmount = document.querySelector('[cart-subscription-amount]');
    const cartCaptionShipping = document.querySelector('[cart-subscription-shipping]');
    const cartCaptionTotal = document.querySelector('[cart-subscription-total]');

    if (subscriptionType === ONE_TIME) {
        subscriptionMembershipTextContainer.style.display = 'none';
        subscriptionMembershipText.style.display = 'none';
        subscriptionOneTimeTextContainer.style.display = 'flex';
        return;
    } else {
        subscriptionOneTimeTextContainer.style.display = 'none';
        subscriptionMembershipText.style.display = 'flex';

        cartCaptionAmount.innerText = subscriptionCartAmount;

        subscriptionCartAmount = subscriptionCartAmount > 12 ? 12 : subscriptionCartAmount;
        cartCaptionShipping.innerHTML = getDateFromToday(subscriptionCartAmount * 30).toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' });
        cartCaptionTotal.innerHTML = formatMoney(subscriptionSubtotal);

        if (subscriptionCartAmount === 0) {
            subscriptionMembershipTextContainer.style.display = 'none';
        } else {
            subscriptionMembershipTextContainer.style.display = 'flex';
        }
    }
};

const countSubscriptionCartAmount = (ecoPackCartItems) => {
    subscriptionSubtotal = 0;
    subscriptionCartAmount = 0;

    for (const ecoPack of ecoPackCartItems) {
        if (ecoPack.cart) {
            subscriptionSubtotal += ecoPack.cart.quantity * ecoPack.cart.price;
            subscriptionCartAmount += ecoPack.cart.quantity;
        };
    }
}

const handleSwitchSubscription = async (type) => {
    showHideLoading(true);

    const isTypeExist = subscriptionTypes.includes(type);
    if (!isTypeExist) {
        return;
    }
    chosenSubscriptionType = type;

    await handleDeleteEcoPacksFromCart(ecoPackCollectionItems);
    await handleAddEcoPacks(ecoPackCartItems, type);
    const response = await fetchCart();
    refreshCart(response, 'handleSwitchSubscription');
};

const addOrRemoveGift = async (cart, source) => {
    showHideLoading(true);

    const sellingPlan = JSON.parse(window.shippingBar.giftSellingPlanIds);
    const sellingPlanIndex = subscriptionCartAmount > 12 ? 11 : subscriptionCartAmount - 1;

    await updateCart(JSON.stringify({ updates: {[freeGiftId]: 0} }));
    await updateCart(JSON.stringify({ updates: {[freeGiftId]: 0} }));
    await updateCart(JSON.stringify({ updates: {[freeGiftId]: 0} }));

    const addToCartGiftItemData = {
        id: freeGiftId,
        quantity: 1,
    };

    if (chosenSubscriptionType === MEMBERSHIP) {
        addToCartGiftItemData.selling_plan = sellingPlan[sellingPlanIndex];
    }

    if (isGiftCriteriaConsistent) {
        try {
            await addToCart(JSON.stringify({
                items: [addToCartGiftItemData],
            }));

            await addNonGiftToCart(cart, source);

            const response = await fetchCart();
            refreshCart(response, 'addOrRemoveGift');
        } catch (err) {
            console.log('CONNECTION ERROR');
        }
    } else {
        await addNonGiftToCart(cart, source);

        const response = await fetchCart();
        refreshCart(response, 'addOrRemoveGift');
    }
};

const getNonGiftQuantity = (cart) => {
    const isCartNotEmpty = Array.isArray(cart.items) && cart.items.length;

    if (!isCartNotEmpty) return 0;

    const findNonGiftProduct = cart.items.filter((item) => item.final_price && item.variant_id === freeGiftId);
    const isNonGiftProductFound = Array.isArray(findNonGiftProduct) && findNonGiftProduct.length;
    let nonGiftProductQuantity = isNonGiftProductFound ? findNonGiftProduct[0].quantity : 0;
    return nonGiftProductQuantity;
}

const addNonGiftToCart = async (cart, source) => {
    const isCartNotEmpty = Array.isArray(cart.items) && cart.items.length;

    if (!isCartNotEmpty) return;

    const findNonGiftProduct = cart.items.filter((item) => item.final_price && item.variant_id === freeGiftId);
    const isNonGiftProductFound = Array.isArray(findNonGiftProduct) && findNonGiftProduct.length;
    const chosenSubscriptionTypePreviousState = chosenSubscriptionTypePreviousStates.length === 1 ? chosenSubscriptionTypePreviousStates[0] : chosenSubscriptionTypePreviousStates[chosenSubscriptionTypePreviousStates.length - 2];
    const isGiftCriteriaConsistentPreviousState = isGiftCriteriaConsistentPreviousStates.length === 1 ? isGiftCriteriaConsistentPreviousStates[0] : isGiftCriteriaConsistentPreviousStates[isGiftCriteriaConsistentPreviousStates.length - 2];
    const isGiftNeedToAdd = isGiftCriteriaConsistent && !isGiftCriteriaConsistentPreviousState;
    const isGiftNeedToRemove = !isGiftCriteriaConsistent && isGiftCriteriaConsistentPreviousState;
    const isLastRenderBySwitchingSubscription = source === 'handleSwitchSubscription';
    const isSwitchedFromMembership = chosenSubscriptionTypePreviousState === MEMBERSHIP && chosenSubscriptionType === ONE_TIME;

    if (!isNonGiftProductFound && !isGiftNeedToAdd && !(isSwitchedFromMembership && isGiftCriteriaConsistentPreviousState)) return;

    let nonGiftProductQuantity = isNonGiftProductFound ? findNonGiftProduct[0].quantity : 0;
    if (nonGiftProductQuantity === 1 && isGiftNeedToRemove && !isSwitchedFromMembership && chosenSubscriptionType === ONE_TIME) {
        nonGiftProductQuantity--;
    }

    if (isLastRenderBySwitchingSubscription && isGiftCriteriaConsistent && chosenSubscriptionType === MEMBERSHIP) nonGiftProductQuantity--;
    if (isGiftNeedToRemove && chosenSubscriptionTypePreviousState === chosenSubscriptionType && chosenSubscriptionType === ONE_TIME) nonGiftProductQuantity--;

    if (nonGiftProductQuantity < 1) return;

    const nonGiftData = {
        "id": freeGiftId,
        "quantity": nonGiftProductQuantity,
    };

    try {
        await addToCart(JSON.stringify({
            items: [nonGiftData],
        }));

        return true;
    } catch (error) {
        console.log("CONNECTION ERROR");
    }
};

const handleDeleteEcoPacksFromCart = async (products) => {
    showHideLoading(true);

    const updates = {};
    for (const product of products) {
        if (Array.isArray(product.variants) && product.variants.length) {
            updates[product.variants[0].id] = 0;
        } else {
            console.log("Unexpected error product variants is not array");
        };
    }

    const response = await updateCart(JSON.stringify({
        updates: updates
    }));

    return response;
}

const handleAddEcoPacks = async (products, subscriptionType) => {
    showHideLoading(true);

    let body = [];
    for (const product of products) {
        const isProductCartDataExist = typeof product.cart === 'object' && product.cart !== null;
        if (!isProductCartDataExist) {
            continue;
        }

        const productVariantId = product.cart.variant_id;
        const productInCartQuantity = product.cart.quantity;
        const sellingPlanIndex = subscriptionCartAmount > 12 ? 11 : (subscriptionCartAmount ? subscriptionCartAmount - 1 : 0);
        const sellingPlan = product.selling_plan_groups[0].selling_plans[sellingPlanIndex].id;
        let addToCartDataItem = {
            "id": productVariantId,
            "quantity": productInCartQuantity,
        };

        if (subscriptionType === MEMBERSHIP) {
            addToCartDataItem.selling_plan = sellingPlan;
        };

        body = [
            ...body,
            addToCartDataItem,
        ];
    }

    if (!body.length) {
        return true;
    }

    const response = await addToCart(JSON.stringify({
        items: body
    }));

    return true;
};

subscriptionSwitchers.forEach((item) => {
    item.addEventListener("change", (e) => {
        handleSwitchSubscription(e.target.value);
    });
});

starterKitColors.forEach((item) => {
    item.addEventListener("change", (e) => {
        e.target.setAttribute("checked", true);
        variantId = e.target.getAttribute("data-variant");
    })
});

const handleAddKitItem = async() => {
    if (!variantId) return;

    showHideLoading(true);
    const addKitItem = document.querySelector(".add-kit-item");

    try {
        await addToCart(JSON.stringify({
            "id": variantId,
            "quantity": 1,
        }))

        const response = await fetchCart();
        addKitItem.classList.remove("active");
        refreshCart(response, 'handleAddKitItem');
    } catch (err) {
        console.log("CONNECTION ERROR");
    }
};

addStarterKitButton.addEventListener("click", handleAddKitItem);

const isEcoPack = (productVariantId) => {
    const ecoPacksVariants = Array.isArray(ecoPackCartItems) &&  ecoPackCartItems.length && ecoPackCartItems[0] && typeof ecoPackCartItems[0] === 'object' && Array.isArray(ecoPackCartItems[0].variants) && ecoPackCartItems[0].variants.length ? ecoPackCartItems.map((item) => item.variants) : [];
    const ecoPackVariantIdsSeparately = ecoPacksVariants.map((variants) => variants.map((variant) => variant.id));
    const ecoPackVariantIds = ecoPackVariantIdsSeparately.reduce((prevVariantIds, variantIds) => [...prevVariantIds, ...variantIds]);
    const isEcoPack = ecoPackVariantIds.includes(productVariantId);
    return isEcoPack;
}


const handleAddToCart = async (productVariantId, quantity, source) => {
    showHideLoading(true);

    const isProductEcoPack = isEcoPack(productVariantId);

    if (isProductEcoPack && chosenSubscriptionType === MEMBERSHIP) {
        let subscriptionCartAmountNewState = 0;
        subscriptionCartAmountNewState += quantity;
        const updateData = {};
        const addToCartData = {
            items: [],
        };
        for (const ecoPackCartItem of ecoPackCartItems) {
            const variantId = ecoPackCartItem.variants[0].id;

            if (variantId != productVariantId && ecoPackCartItem.cart) {
                subscriptionCartAmountNewState += ecoPackCartItem.cart.quantity;
            }

            updateData[variantId] = 0;

            let productQuantityNewState = 0;
            if (productVariantId == variantId) {
                productQuantityNewState = quantity;
            } else if (ecoPackCartItem.cart) {
                productQuantityNewState = ecoPackCartItem.cart.quantity;
            }

            if (productQuantityNewState > 0) {
                addToCartData.items = [
                    ...addToCartData.items,
                    {
                        id: variantId,
                        quantity: productQuantityNewState,
                    }
                ];
            }
        }

        const sellingPlanIndex = subscriptionCartAmountNewState > 12 ? 11 : (subscriptionCartAmountNewState ? subscriptionCartAmountNewState - 1 : 0);
        const ecoPackSellingPlans = {};
        for (const ecoPackCartItem of ecoPackCartItems) {
            const variantId = ecoPackCartItem.variants[0].id;
            const sellingPlan = ecoPackCartItem.selling_plan_groups[0].selling_plans[sellingPlanIndex].id;
            ecoPackSellingPlans[variantId] = sellingPlan;
        }

        for (const addToCartDataItem of addToCartData.items) {
            addToCartDataItem.selling_plan = ecoPackSellingPlans[addToCartDataItem.id];
        }

        try {
            await updateCart(JSON.stringify({ updates: updateData }));

            await addToCart(JSON.stringify( addToCartData ));

            const cartData = await fetchCart();
            refreshCart(cartData, source);
        } catch (err) {
            console.log('CONNECTION ERROR');
        }
    } else {
        const data = {
            "id": productVariantId,
            "quantity": quantity,
        };

        try {
            await addToCart(JSON.stringify(data));

            const response = await fetchCart();

            refreshCart(response, source);
        } catch (err) {
            console.log("CONNECTION ERROR");
        }
    }
}


const handleUpdateCartItemQuantity = async (productVariantId, value, buttonName, subscriptionType) => {
    showHideLoading(true);

    const quantityToUpdate = buttonName ? (buttonName === 'plus' ? Number(value) + 1 : Number(value) - 1) : (!isNaN(Number(value)) ? Number(value) : 0);
    const isProductEcoPack = isEcoPack(productVariantId);

    if (isProductEcoPack && chosenSubscriptionType === MEMBERSHIP) {
        let subscriptionCartAmountNewState = 0;
        subscriptionCartAmountNewState += quantityToUpdate;
        const updateData = {};
        const addToCartData = {
            items: [],
        };
        for (const ecoPackCartItem of ecoPackCartItems) {
            const variantId = ecoPackCartItem.variants[0].id;

            if (variantId != productVariantId && ecoPackCartItem.cart) {
                subscriptionCartAmountNewState += ecoPackCartItem.cart.quantity;
            }

            updateData[variantId] = 0;

            let productQuantityNewState = 0;
            if (productVariantId == variantId) {
                productQuantityNewState = quantityToUpdate;
            } else if (ecoPackCartItem.cart) {
                productQuantityNewState = ecoPackCartItem.cart.quantity;
            }

            if (productQuantityNewState > 0) {
                addToCartData.items = [
                    ...addToCartData.items,
                    {
                        id: variantId,
                        quantity: productQuantityNewState,
                    }
                ];
            }
        }

        const sellingPlanIndex = subscriptionCartAmountNewState > 12 ? 11 : (subscriptionCartAmountNewState ? subscriptionCartAmountNewState - 1 : 0);
        const ecoPackSellingPlans = {};
        for (const ecoPackCartItem of ecoPackCartItems) {
            const variantId = ecoPackCartItem.variants[0].id;
            const sellingPlan = ecoPackCartItem.selling_plan_groups[0].selling_plans[sellingPlanIndex].id;
            ecoPackSellingPlans[variantId] = sellingPlan;
        }

        for (const addToCartDataItem of addToCartData.items) {
            addToCartDataItem.selling_plan = ecoPackSellingPlans[addToCartDataItem.id];
        }

        try {
            await updateCart(JSON.stringify({ updates: updateData }));

            const isAddToCartDataExist = Array.isArray(addToCartData.items) && addToCartData.items.length;
            if (isAddToCartDataExist) {
                await addToCart(JSON.stringify( addToCartData ));
            }

            const cartData = await fetchCart();
            refreshCart(cartData);
        } catch (err) {
            console.log('CONNECTION ERROR');
        }
    } else {
        let updates = {
            [productVariantId]: quantityToUpdate
        };

        try {
            const response = await updateCart(JSON.stringify({ updates }));

            refreshCart(response);
        } catch (err) {
            console.log('CONNECTION ERROR');
        }
    }
}

const handleEditColor = (productVariantId, selectedItem, index) => {
    const cartItem = document.querySelector(`[data-id="${productVariantId}-${index}"]`);

    selectedItem.nextElementSibling.classList.toggle("edit_color-open");
    cartItem.classList.toggle("cart_item-active");

    if (selectedItem.nextElementSibling.classList.contains("edit_color-open")) {
        selectedItem.innerHTML = "close";
    } else {
        selectedItem.innerHTML = "edit color";
    }
};

const handleUpdateColor = async (oldProductVariantId, productVariantId) => {
    if (oldProductVariantId == productVariantId) return;
    showHideLoading(true);

    const findProductInCartQuantityPrevState = starterKitCartItems.filter((product) => product.cart && product.cart.variant_id == oldProductVariantId);
    const isProductInCartQuantityPrevStateExist = findProductInCartQuantityPrevState.length;
    let productInCartQuantityPrevState = isProductInCartQuantityPrevStateExist ? Number(findProductInCartQuantityPrevState[0].cart.quantity) : 0;
    const oldProductNeedToUpdateInCartQuantity = productInCartQuantityPrevState > 0 ? productInCartQuantityPrevState - 1 : 0;

    await updateCart(JSON.stringify({
        updates: {
            [oldProductVariantId]: oldProductNeedToUpdateInCartQuantity
        }
    }));

    handleAddToCart(productVariantId, 1, 'handleUpdateColor');
}

const handleDeleteStarterKit = async (oldProductVariantId) => {
    showHideLoading(true);

    const findProductInCartQuantityPrevState = starterKitCartItems.filter((product) => product.cart && product.cart.variant_id == oldProductVariantId);
    const isProductInCartQuantityPrevStateExist = findProductInCartQuantityPrevState.length;
    let productInCartQuantityPrevState = isProductInCartQuantityPrevStateExist ? Number(findProductInCartQuantityPrevState[0].cart.quantity) : 0;
    const oldProductNeedToUpdateInCartQuantity = productInCartQuantityPrevState > 0 ? productInCartQuantityPrevState - 1 : 0;

    await updateCart(JSON.stringify({
        updates: {
            [oldProductVariantId]: oldProductNeedToUpdateInCartQuantity
        }
    }));

    const response = await fetchCart();
    refreshCart(response, 'handleDeleteStarterKit');
}

const toggleMembershipButton = (subscriptionType) => {
    subscriptionSwitchers.forEach((item) => {
        if (item.value === subscriptionType) {
            item.setAttribute("checked", true);
        } else {
            item.removeAttribute("checked");
        }
    });
}

const getEcoPackPrice = (price, isProductCartDataExist, subscriptionType) => {
    if (isProductCartDataExist || subscriptionType === ONE_TIME) {
        return price;
    }

    if (ecoPackItemSellingPlanDiscountDataForMembership.value_type != 'percentage') {
        return price;
    }

    const discountPercentage = ecoPackItemSellingPlanDiscountDataForMembership.value;
console.log(ecoPackItemSellingPlanDiscountDataForMembership)
    let formatedPrice = price - price * discountPercentage / 100;

    return formatedPrice;
}

const renderCartItems = (products, collectionHandle, subscriptionType, renderingTemporaryProducts) => {
    showHideLoading(true);
    const temporaryProducts = [];
    const itemsContainer = document.querySelector('#' + collectionHandle);
    let itemsMarkup = '';

    const clearTitle = (title) => {
        return title.replace('(', '<span>(').replace(')', ')</span>').replace('incl. ', '');
    }

    for (const [index, product] of products.entries()) {
        const isProductCartDataExist = typeof product.cart === 'object' && product.cart !== null;
        const productImage = isProductCartDataExist ? product.cart.image : product.featured_image;
        const productTitle = isProductCartDataExist ? product.cart.title : product.title;
        const productPrice = isProductCartDataExist ? product.cart.price : product.price;
        const productInCartQuantity = isProductCartDataExist ? product.cart.quantity : 0;
        const productVariantId = isProductCartDataExist ? product.cart.variant_id : product.variants[0].id;
        const productPriceWithoutDiscount = isProductCartDataExist && typeof product.cart.selling_plan_allocation === 'object' && product.cart.selling_plan_allocation !== null && product.cart.selling_plan_allocation.compare_at_price ? product.cart.selling_plan_allocation.compare_at_price : null;

        let isGiftWhenOneTime = false;
        if (isProductCartDataExist && Array.isArray(product.cart.discounts) && product.cart.discounts.length) {
            const findDiscount = product.cart.discounts.filter((discount) => discount.title === FREE_GIFT_DISCOUNT_TITLE);
            isGiftWhenOneTime = findDiscount.length;
        }
        let isGiftWhenMembership = isProductCartDataExist && product.cart.price === 0;
        const isGift = isGiftWhenOneTime || isGiftWhenMembership;

        if (isGift && !renderingTemporaryProducts) {
            temporaryProducts.push(product);
            continue;
        }

        itemsMarkup += `
            ${
                isGift ?
                    `<h2 class="extra_title extra_title-gift">free gift</h2><div>&nbsp;</div>`
                : ''
            }
            <div class="cart_starter-kit-item" data-id=${productVariantId + '-' + index}>
                <div class="cart_starter_kit-img-wrapper">
                    <img class="cart-starter_kit__img" src=${productImage} alt=${product.handle} loading="lazy">
                </div>
                <div class="cart-starter-kit-item__content">
                    <div class="cart-kit-item__content-desc">
                        <div class="cart-starter-kit-item__title">${clearTitle(productTitle)}</div>
                        <div class="cart-starter-kit-item__price">
                            <span>${formatMoney(isGiftWhenOneTime ? 0 : (collectionHandle === ecoPacksCollectionHandle ? getEcoPackPrice(productPrice, isProductCartDataExist, subscriptionType) : productPrice))}</span>
                            ${productPriceWithoutDiscount || isGiftWhenOneTime || (collectionHandle === ecoPacksCollectionHandle && subscriptionType === MEMBERSHIP) ?
                                `<span class='price--discount'>${formatMoney(isGiftWhenOneTime || (collectionHandle === ecoPacksCollectionHandle && subscriptionType === MEMBERSHIP) ? (isProductCartDataExist && collectionHandle === ecoPacksCollectionHandle && subscriptionType === MEMBERSHIP ? product.price : productPrice) : productPriceWithoutDiscount)}</span>` : ''}
                        </div>
                    </div>
                    ${collectionHandle === "frontpage" ?
                        `
                            <div class="cart-kit-item__content-right cart_item-edit">
                                <div onclick="handleDeleteStarterKit(${productVariantId})" class="cart-kit-item__remove">
                                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove"><g fill="none" fill-rule="evenodd"><path d="M0 20h20V0H0z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M2.152 2.978h15.696M13.304 2.978H6.695V2.81A2.31 2.31 0 0 1 9.005.5h1.99a2.31 2.31 0 0 1 2.31 2.31v.168zM10 6.282v9.913M6.695 6.282v9.913m6.609-9.913v9.913m.121 3.305h-6.85A2.48 2.48 0 0 1 4.1 17.145L3.391 2.978H16.61l-.71 14.167a2.478 2.478 0 0 1-2.475 2.355z"></path></g></svg>
                                </div>
                                <div class="edit-color">
                                    <div class="edit-color_text" data-toggle="" onclick="handleEditColor(${productVariantId}, this, ${index})" data-edit="edit color" data-close="close">edit color</div>
                                    <div class="edit-color__color-list">
                                        ${Object.keys(availableVariantsBgColors).map((key, index) => {
                                            return `
                                                <label class="edit-color__color-item">
                                                    <input
                                                        type="radio"
                                                        onclick="handleUpdateColor(${productVariantId}, ${key})"
                                                        name="variant-${key + '-' + index}"
                                                        value=""
                                                        data-price="${productPrice}"
                                                        data-quantity="${productInCartQuantity}"
                                                        data-variant="${key}"
                                                        ${productVariantId == key && 'checked'}
                                                    >
                                                    <div class="edit-color__color" style="background-color: ${availableVariantsBgColors[key]}; 
                                                      ${ secoundAvailableVariantsBgColors[key] && `position: relative; overflow: hidden; border: 2px solid ${availableVariantsBgColors[key]}`
                                                        }">
                                                    ${secoundAvailableVariantsBgColors[key] &&
                                                      `<span style="width: 60px; height: 30px; position: absolute; top: -5px; left: 1px; transform: rotate(45deg); background-color: ${secoundAvailableVariantsBgColors[key]}"></span>`
                                                    }
                                                  </div>
                                                </label>
                                            `
                                        }).join('')}
                                    </div>
                                </div>
                            </div>
                        ` : (!isGift ? `
                        <div class="cart-item__controls cart-item__inputs">
                        ${productInCartQuantity <= 0 ?
                            `
                                <button onclick="handleAddToCart(${productVariantId}, 1)" class="button button--primary cart-item__btn cart_btn" data-add-button="">add</button>
                            ` : `
                                <div class="quantity cart-item__quantity">
                                    <button class="quantity__button" name="minus" onclick="handleUpdateCartItemQuantity(${productVariantId}, ${productInCartQuantity}, 'minus')" type="button">
                                        <span class="visually-hidden">Decrease quantity for arugula superfood</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 12 2" fill="currentColor"><path d="M0 0h12v2H0z" fill-rule="evenodd"></path></svg>
                                    </button>
                                    <input class="quantity__input" onchange="handleUpdateCartItemQuantity(${productVariantId}, this.value)" type="number" name="quantity" min="0" value=${productInCartQuantity}>
                                    <button class="quantity__button" name="plus" type="button" onclick="handleUpdateCartItemQuantity(${productVariantId}, ${productInCartQuantity}, 'plus')">
                                        <span class="visually-hidden">Increase quantity for arugula superfood</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 12 12" fill="currentColor"><g fill-rule="evenodd"><path d="M0 5h12v2H0z"></path><path d="M5 0h2v12H5z"></path></g></svg>
                                    </button>
                                </div>
                            `
                            }
                        </div>
                    ` : '')
                }
                </div>
            </div>
        `;
    }

    itemsContainer.innerHTML = (renderingTemporaryProducts ? itemsContainer.innerHTML : '') + itemsMarkup;

    if (!renderingTemporaryProducts) {
        renderCartItems(temporaryProducts, collectionHandle, subscriptionType, true);
    }
};

const setSubscriptionType = (ecoPackCartItems) => {
    const isEcoPacCartItemExist = Array.isArray(ecoPackCartItems) && ecoPackCartItems.length;
    if (!isEcoPacCartItemExist) {
        return;
    }

    const findEcoPacksInCart = ecoPackCartItems.filter((item) => item.cart);
    const isEcoPackProductCartDataExist = findEcoPacksInCart.length;
    if (!isEcoPackProductCartDataExist) {
        return;
    }
    const ecoPackProduct = findEcoPacksInCart[0];
    const haveSellingPlan = ecoPackProduct.cart.selling_plan_allocation;

    if (haveSellingPlan) {
        chosenSubscriptionType = MEMBERSHIP;
    } else {
        chosenSubscriptionType = ONE_TIME;
    }

    chosenSubscriptionTypePreviousStates.push(chosenSubscriptionType);
}

const renderCartTotalPrice = (price) => {
    const cartFinnalPriceWrapper = document.querySelector('#cart_finnal-price-wrapper');
    cartFinnalPriceWrapper.innerHTML = formatMoney(price);
};

const showHideLoading = (loading) => {
    const cartLoader = document.querySelector(".loader");

    if (loading) {
        cartLoader.style.display = "flex";
        return;
    }

    cartLoader.style.display = "none";
};

const progressBarUpdate = () => {
    const progressBarText = document.querySelector(".cart-progress-bar__text");
    const progressBarValue = document.querySelector(".cart-progress-bar__progress-value");
    const shippingAmount = Number(window.shippingBar.shippingAmount);
    const giftAmount = Number(window.shippingBar.giftAmount);

    if (shippingAmount > subscriptionCartAmount) {
        progressBarText.innerHTML = `
            <p>
                füge 
                <span data-free-shipping>${shippingAmount - subscriptionCartAmount}</span>
                superfoods hinzu und sicher dir 
                <strong>gratis versand!</strong>
            </p>
        `
    } else if (giftAmount > subscriptionCartAmount) {
        progressBarText.innerHTML = `
            <p>
                glückwunsch, du bekommst 
                <strong class="color-green">
                    freien versand!
                </strong>
            </p>
            <p>
                fast geschafft, füge <strong>${giftAmount - subscriptionCartAmount}</strong>  superfoods hinzu und bekomme <strong>ein gratis geschenk</strong>
            </p>
        `
    } else {
        progressBarText.innerHTML = `
            <p>
                glückwunsch, mit deiner bestellung bekommst du
                <strong class="color-green"> freien versand </strong>
                und ein
                <strong class="color-green"> gratis geschenk </strong>
            </p>
        `
    }

    let shippingProgressInit = window.innerWidth > 750 ? 0.8 : 0.6;

    progressBarValue.style.width = `calc( ${Math.round(subscriptionCartAmount * 100 / giftAmount)}% + ${shippingProgressInit}rem)`;
}


const toggleGiftCriteriaConsistent = (ecoPackCartItems) => {
    let ecoPacksQuantity = 0;
    for (const ecoPack of ecoPackCartItems) {
        if (ecoPack.cart) {
            ecoPacksQuantity += ecoPack.cart.quantity;
        };
    }

    if (ecoPacksQuantity >= giftConsistentQuantity) {
        isGiftCriteriaConsistent = true;
    } else {
        isGiftCriteriaConsistent = false;
    }

    isGiftCriteriaConsistentPreviousStates.push(isGiftCriteriaConsistent);
}



const cartCountHeader = (cart) => {
    cartCount.classList.add("cart-count");

    if (cart.item_count > 0) {
        cartCount.innerHTML = cart.item_count;
        cartCount.classList.remove("cart-count-empty");
    } else {
        cartCount.classList.add("cart-count-empty");
    }
}

const refreshCart = (cart, source) => {
    const isCartDataValid = typeof cart === 'object' && cart !== null;
    if (!isCartDataValid) return;

    cart = cart;

    const itemsInCart = cart.items;
    const isItemsInCartValid = Array.isArray(itemsInCart);
    if (!isItemsInCartValid) return;

    ecoPackCartItems = generateCartItems(itemsInCart, ecoPacksCollectionHandle);
    setSubscriptionType(ecoPackCartItems);
    renderCartItems(ecoPackCartItems, ecoPacksCollectionHandle, chosenSubscriptionType);
    countSubscriptionCartAmount(ecoPackCartItems);
    renderSubscriptionText(chosenSubscriptionType);
    toggleMembershipButton(chosenSubscriptionType);
    toggleGiftCriteriaConsistent(ecoPackCartItems);
    if (source !== 'addOrRemoveGift' && source !== 'initCart' && source !== 'handleAddKitItem' && source !== 'handleUpdateColor' && source !== 'handleDeleteStarterKit') addOrRemoveGift(cart, source);

    starterKitCartItems = generateCartItems(itemsInCart, starterKitCollectionHandle);
    renderCartItems(starterKitCartItems, starterKitCollectionHandle, chosenSubscriptionType);

    extraCartItems = generateCartItems(itemsInCart, extraCollectionHandle);
    renderCartItems(extraCartItems, extraCollectionHandle, chosenSubscriptionType);

    renderCartTotalPrice(cart.total_price);
    progressBarUpdate();
    cartCountHeader(cart);

    if (source === 'addOrRemoveGift' || source === 'initCart' || source === 'handleAddKitItem' || source === 'handleUpdateColor' || source === 'handleDeleteStarterKit') showHideLoading(false);
};

const initCart = () => {
    refreshCart(cart, 'initCart');
};

initCart();

